import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Link } from "react-scroll";
import './reviews_slider.css'
import stars from '../../../img/main/stars.png'

export default class DemoCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliders: [
                {
                    name: ``,
                    review: ``,
                },
                {
                    name: `Erwin Abelardo Pacheco`,
                    review: `I am grateful to hear from industry's practitioners, best practices, correct approaches thru fundamentals (various architecture concepts and case-based applications), scalability thru available microservices and options to revert or migrate, and the thought of realizing business solutions.`,
                },
                {
                    name: `Gustavo Dalla Nora`,
                    review: `It was a very rich learning experience to be able to see what people with Software Architecture roles in companies around the world are doing to talke Software Architecture challenges in modern industry.`,
                },
                {
                    name: `Prabu Varadharajalu Sivakumar`,
                    review: `Thoroughly blessed to be a part of this event. Had great opportunity to learn from Industry Experts. Though there are technical glitches, the show went on. There was always a back up process and very thoughtful insights. I’ve enrolled to all the 20 sessions in 2021. Can’t wait to learn from every track.`,
                },
            ],
        }
    }

    render() {
        return (
            <div className='main_slider'>
                <Carousel showStatus={false} swipeable emulateTouch infiniteLoop>
                    <div className='main_review_block'>
                        <img className='review_stars' src={stars} alt="" />
                        <div className='review_text p2'>
                            <p>Thoroughly blessed to be a part of this event. Had great opportunity to learn from Industry Experts. Though there are technical glitches... <Link
                                activeClass="active"
                                to='reviews'
                                spy={true}
                                smooth={true}
                                offset={-44}
                                className='review_btn review_btn--nowrap'
                            >
                                READ MORE
                            </Link>
                            </p>
                        </div>
                        <p className='review_name'>Prabu Varadharajalu Sivakumar</p>
                    </div>
                    <div className='main_review_block'>
                        <img className='review_stars' src={stars} alt="" />
                        <div className='review_text p2'>
                            <p>I am grateful to hear from industry's practitioners, best practices, correct approaches... <Link
                                activeClass="active"
                                to='reviews'
                                spy={true}
                                smooth={true}
                                offset={-44}
                                className='review_btn review_btn--nowrap'
                            >
                                READ MORE
                            </Link>
                            </p>
                        </div>
                        <p className='review_name'>Erwin Abelardo Pacheco</p>
                    </div>
                    <div className='main_review_block'>
                        <img className='review_stars' src={stars} alt="" />
                        <div className='review_text p2'>
                            <p>It was a very rich learning experience to be able to see what people with Software Architecture roles in companies around the... <Link
                                activeClass="active"
                                to='reviews'
                                spy={true}
                                smooth={true}
                                offset={-44}
                                className='review_btn review_btn--nowrap'
                            >
                                READ MORE
                            </Link>
                            </p>
                        </div>
                        <p className='review_name'>Gustavo Dalla Nora</p>
                    </div>
                    <div className='main_review_block'>
                        <img className='review_stars' src={stars} alt="" />
                        <div className='review_text p2'>
                            <p>Attending made me realize I do apply architecture to my day to day work but never knew how much. Also introduced me to new knowledge about... <Link
                                activeClass="active"
                                to='reviews'
                                spy={true}
                                smooth={true}
                                offset={-44}
                                className='review_btn review_btn--nowrap'
                            >
                                READ MORE
                            </Link>
                            </p>
                        </div>
                        <p className='review_name'>Lucía Sarasola</p>
                    </div>
                </Carousel>
            </div>
        )
    }
}